import React from 'react';
import Header from '../../componentes/comuns/Header';
import Footer from '../../componentes/comuns/Footer';
import FAQ from '../../componentes/comuns/FAQ';




const Perguntas = () => {
    return (
        <>

            <Header />
            <main>

                <div>
                    <FAQ />
                </div>

            </main>
            <Footer />
        </>
    );
}

export default Perguntas;